import exampleImg from "@/components/Common/ExampleImgUploader/ExampleImgUploader.vue";

const exampleImgUploader = {
  install: function (Vue) {
    Vue.component('exampleImgUploader', exampleImg);
  }
}
export default exampleImgUploader;